/**
 * Created by imranexpt on 23/02/2017.
 */
(function() {
    /** @ngInject */
    function mealsPageController($scope,$http,waCalendar, Booking) {
        //var foundOrder = false;
        for(var x in meals){
            meals[x]['orderby'] = _.parseInt(meals[x]['orderby']);
        }
        $scope.meals = hash === '41216a0170e7bcb819a74eafe8d54a3d' ? [] : _.sortBy(meals, function(m){
            if(m.orderby > 0) foundOrder = true;
            return m.orderby;
        });
        $scope.askForMcCode = settings.mc_code_group;
        $scope.mc_enabled = settings.mc_enabled;
        $scope.default_text = default_text;
        $scope.show_mc_field = false;
        $scope.selectedMeal = null;
        $scope.takeoutPos = settings.takeaway_pos;
        $scope.giftcards = giftcards;
        $scope.canMealBeShownInList = function(meal){
            if(meal.type == 12) return false;
            if(meal.type == 8 || meal.type == 10) return false;
            if(meal.type == 11) return is_t;
            return true;
        };
        $scope.selectGiftcard = function(giftcard, e){
            if(typeof(e) !== 'undefined' && e.target && e.target.nodeName === 'A') return;
            $scope.booking.setGiftcard(giftcard);
            $scope.goTo('giftcard');
        };
        $scope.selectMeal = function(meal, e){
            if(typeof(e) !== 'undefined' && e.target && e.target.nodeName === 'A') return;
            if(!meal.started) return false;
            $scope.selectedMeal = meal;
            $scope.booking.setMeal(meal);
            if($scope.mc_enabled === 'Y' && _.includes(settings.mc_meals,meal.id)){
                $scope.show_mc_field = true;
                return false;
            }else {
                if (typeof(dataLayer) !== 'undefined') {
                    //dataLayer.push({'event': 'Choose-meal'});
                    if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'waiterAidMessage' , 'message' : {'step' : 'Choose-meal'}}); }
                }
                if(meal.type == 9){
                    $scope.booking.amount = 1;
                    $scope.goTo('calendar');
                }else if (meal.type == 8) {
                    $scope.booking.setTime('00:00');
                    $scope.goTo('products');
                }else if( meal.type == 10){
                    $scope.booking.setTime('17:00');
                    $scope.goTo('products');
                }else{
                    $scope.goTo('amounts');
                }
            }
        };
        $scope.getMCMealsList = function(){
            $http.post("/booking-widget/api/getMealsListByCode", {hash : hash,  mc_code : $scope.booking.mc_code}).then(function (response) {
                if(response.data.success !== true ){
                    alert(response.data.errors); return false;
                }
                meals = response.data.meals;
                for(var x in meals){
                    meals[x]['orderby'] = _.parseInt(meals[x]['orderby']);
                }
                $scope.meals = _.sortBy(meals, function(m){
                    if(m.orderby > 0) foundOrder = true;
                    return m.orderby;
                });
                $scope.setMeals($scope.meals);
                settings.mc_meals = [];
                $scope.askForMcCode = false;
            });
        };
        $scope.specialMeals = _.filter($scope.meals, function(m){ return _.parseInt(m.type) === 8; });
        $scope.takeoutMeals = settings.take_out_meals ? _.filter($scope.meals, function(m){ return _.parseInt(m.type) === 10; }) : [];
        updateWidgetStep('Meals');
        $scope.selectMealByCode = function(){
            if($scope.booking.mc_code.length > 2){
                $http.post("/booking-widget/api/validateMealCode", {hash : hash, mealid: $scope.booking.mealid, mc_code : $scope.booking.mc_code}).then(function (response) {
                    if (response.data.success !== true) {
                        alert(response.data.errors);
                    } else {
                        if(_.has(response.data,'meal') && response.data.meal !== false) {
                            meals[$scope.booking.mealid] = response.data.meal;
                            $scope.setMeals(meals);
                        }
                        var cls = [];
                        if(_.has(response.data,'max_time')){
                            if(_.has(settings,'start_month')) {
                                var start_date = moment.tgz(settings.start_month);
                                if(moment.tgz().isBefore(start_date,'month')){
                                    var m_diff = start_date.diff(moment.tgz(),'months');
                                    if(m_diff > 0)
                                        max_time = max_time-m_diff;
                                    //if(moment(start_date).add(max_time,"months"))
                                    Booking.setDate(start_date);
                                    $scope.date = Booking.getDate('YYYY-MM-DD');
                                }
                                max_time = max_time+1;
                                //Booking.setDate(settings.start_month);
                            }


                            var _dd = moment(angular.copy($scope.date));
                            for(var i=1;i<=((max_time) || 3);i++){
                                _dd.date(1);
                                cls.push(
                                    new waCalendar({date : _dd.format("YYYY-MM-DD"), max_month_diff : max_time})
                                );
                                _dd.add(1,"month");
                            }
                            $scope.setCalendars(cls);
                        }
                        //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-meal'}); }
                        if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'waiterAidMessage' , 'message' : {'step' : 'Choose-meal'}}); }
                        if($scope.booking.meal.type === 8) {
                            $scope.booking.setTime('00:00');
                            $scope.goTo('products');
                        }else {
                            $scope.goTo('amounts');
                        }
                    }
                });
            }
        };
        $scope.expandText = false;
    }
    angular.module("Waiteraid").controller("mealsCtrl", mealsPageController);
})();
